import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import "../DestinationOffer/DestinationDetails.css";
import { Link } from "react-router-dom";
import WhyChoose from "../WhyChoose/WhyChoose";
import { FaClock, FaPlane, FaPassport, FaCity, FaUsers, FaMoneyBillAlt } from "react-icons/fa";
import Newsletter from "../Newsletter/Newsletter";
import FlightDeal from "../Flight/Flightdeal";
const destinations = [
  {
    id: "turkey",
    image: "/turkey.jpg",
    location: "Cappadocia & Turkish Riviera",
    nights: 7,
    price: 699,
    description: "Discover the magical landscapes of Cappadocia and the stunning coastline of the Turkish Riviera. Explore unique rock formations, take a hot air balloon ride, and relax on beautiful Mediterranean beaches. Experience the perfect blend of natural wonders, rich history, and Turkish hospitality.",
    highlights: [
      "Hot air balloon ride over Cappadocia's fairy chimneys",
      "Explore ancient underground cities",
      "Relax on the turquoise beaches of Antalya",
      "Visit historic sites like Ephesus",
      "Enjoy traditional Turkish cuisine and hammam experience",
      "Sail along the stunning Turquoise Coast",
      "Visit the stunning Pamukkale thermal pools"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+3" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "4 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "Yes (e-Visa)" },
      { icon: <FaCity />, label: "Capital City", value: "Ankara" },
      { icon: <FaUsers />, label: "Population", value: "84 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Turkish Lira" }
    ]
  },
  {
    id: "morocco",
    image: "/morocco.jpg",
    location: "Magical Morocco: Sahara & Coast",
    nights: 9,
    price: 899,
    description: "Embark on an extraordinary journey through Morocco's diverse landscapes. From the bustling medinas of Marrakech to the endless Sahara Desert and the beautiful Atlantic coast, experience a land of vibrant culture, ancient traditions, and breathtaking scenery.",
    highlights: [
      "Camel trek in the Sahara Desert",
      "Explore the blue city of Chefchaouen",
      "Visit the historic medinas of Fez and Marrakech",
      "Experience a traditional Berber desert camp",
      "Enjoy Moroccan cooking classes and spice markets",
      "Hike through the stunning Atlas Mountains",
      "Visit the famous Ait Benhaddou kasbah"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+1" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "3 hours 30 minutes" },
      { icon: <FaPassport />, label: "Visa Required", value: "No (for most nationalities)" },
      { icon: <FaCity />, label: "Capital City", value: "Rabat" },
      { icon: <FaUsers />, label: "Population", value: "37 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Moroccan Dirham" }
    ]
  },
  {
    id: "dubai",
    image: "/dubai.jpg",
    location: "Dubai & Abu Dhabi Luxury Experience",
    nights: 8,
    price: 1299,
    description: "Immerse yourself in the ultimate luxury of the United Arab Emirates. From Dubai's futuristic skyline to Abu Dhabi's cultural treasures, experience a perfect blend of modern extravagance and traditional Arabian hospitality.",
    highlights: [
      "Burj Khalifa observation deck experience",
      "Desert safari with dune bashing",
      "Visit Sheikh Zayed Grand Mosque",
      "Luxury yacht cruise in Dubai Marina",
      "Shopping at world-class malls and traditional souks",
      "Experience the Dubai Fountain show",
      "Visit the stunning Louvre Abu Dhabi museum"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+4" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "7 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "Yes (Visa on Arrival)" },
      { icon: <FaCity />, label: "Capital City", value: "Abu Dhabi" },
      { icon: <FaUsers />, label: "Population", value: "9.9 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "UAE Dirham" }
    ]
  },
  {
    id: "maldives",
    image: "/maldives.jpg",
    location: "Indian Ocean Paradise: Maldives",
    nights: 10,
    price: 1999,
    description: "Experience the ultimate tropical paradise in the Maldives. Indulge in luxurious overwater villas, pristine white sandy beaches, and some of the world's most incredible marine life. A perfect escape for those seeking ultimate relaxation and underwater adventures.",
    highlights: [
      "Stay in luxurious overwater villa",
      "Snorkeling and diving in crystal-clear lagoons",
      "Private sunset cruise",
      "Marine life exploration and coral reef tours",
      "Spa treatments with ocean views",
      "Dine at underwater restaurants",
      "Swim with manta rays and whale sharks"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+5" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "10 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "Visa on Arrival" },
      { icon: <FaCity />, label: "Capital City", value: "Malé" },
      { icon: <FaUsers />, label: "Population", value: "540k" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Maldivian Rufiyaa" }
    ]
  },
  {
    id: "thailand",
    image: "/thailand.jpg",
    location: "Thailand: Islands & Culture",
    nights: 12,
    price: 1199,
    description: "Discover the magic of Thailand, from bustling Bangkok to the pristine islands of Phuket and Krabi. Experience a perfect mix of vibrant city life, rich cultural heritage, and tropical paradise beaches with fantastic night life.",
    highlights: [
      "Explore Bangkok's Grand Palace",
      "Island hopping in Phuket and Krabi",
      "Traditional Thai cooking class",
      "Snorkeling in crystal-clear waters",
      "Explore local markets and street food",
      "Visit ancient temples in Chiang Mai",
      "Experience the famous Full Moon Party"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+7" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "11 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "Visa on Arrival" },
      { icon: <FaCity />, label: "Capital City", value: "Bangkok" },
      { icon: <FaUsers />, label: "Population", value: "69.8 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Thai Baht" }
    ]
  },
  {
    id: "indonesia",
    image: "/indonesia.jpg",
    location: "Indonesia: Bali & Beyond",
    nights: 10,
    price: 1299,
    description: "Immerse yourself in the beauty of Indonesia, with a focus on Bali's spiritual landscapes, vibrant culture, and stunning natural beauty. Experience a journey of discovery through lush landscapes, ancient temples, and pristine beaches.",
    highlights: [
      "Explore Ubud's rice terraces",
      "Visit iconic temples like Uluwatu",
      "Traditional Balinese dance performance",
      "Wellness and spa experiences",
      "Surf lessons and beach relaxation",
      "Sunrise hike up Mount Batur volcano",
      "Visit the sacred Monkey Forest in Ubud"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+8" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "15 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "Visa on Arrival" },
      { icon: <FaCity />, label: "Capital City", value: "Jakarta" },
      { icon: <FaUsers />, label: "Population", value: "273 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Indonesian Rupiah" }
    ]
  },
  {
    id: "malaysia",
    image: "/malasiya.jpg",
    location: "Malaysia: Modern & Traditional",
    nights: 9,
    price: 1099,
    description: "Experience the unique blend of modernity and tradition in Malaysia. From the futuristic Kuala Lumpur to the historic Penang and pristine beaches of Langkawi, discover a diverse and vibrant destination with fabulous night life.",
    highlights: [
      "Explore Kuala Lumpur's Petronas Towers",
      "Visit historic George Town, Penang",
      "Discover Cameron Highlands",
      "Enjoy Malaysian street food",
      "Relax on Langkawi's beautiful beaches",
      "Explore the Batu Caves temple complex",
      "Visit the historic Malacca City"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+8" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "9 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "No (for many nationalities)" },
      { icon: <FaCity />, label: "Capital City", value: "Kuala Lumpur" },
      { icon: <FaUsers />, label: "Population", value: "32 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Malaysian Ringgit" }
    ]
  },
  {
    id: "india",
    image: "/india.jpg",
    location: "India: Colors & Contrasts",
    nights: 14,
    price: 1499,
    description: "Embark on an incredible journey through India's diverse landscapes and rich cultural heritage. From the iconic Taj Mahal to vibrant cities and serene backwaters, experience a land of extraordinary diversity.",
    highlights: [
      "Visit the Taj Mahal in Agra",
      "Explore the pink city of Jaipur",
      "Experience Kerala's backwaters",
      "Discover spiritual Varanasi",
      "Enjoy authentic Indian cuisine",
      "Wildlife safari in Ranthambore National Park",
      "Visit the Golden Temple in Amritsar"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+5:30" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "8 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "Yes" },
      { icon: <FaCity />, label: "Capital City", value: "New Delhi" },
      { icon: <FaUsers />, label: "Population", value: "1.4 billion" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Indian Rupee" }
    ]
  },
  {
    id: "srilanka",
    image: "/srilanka.jpg",
    location: "Sri Lanka: Island Treasures",
    nights: 8,
    price: 999,
    description: "Discover the tropical paradise of Sri Lanka, with its ancient ruins, lush tea plantations, wildlife reserves, and pristine beaches. A perfect destination for nature lovers and culture enthusiasts with ancient historical places. ",
    highlights: [
      "Explore ancient Sigiriya Rock Fortress",
      "Wildlife safari in Yala National Park",
      "Tea plantation tour in Nuwara Eliya",
      "Relax on beautiful southern beaches",
      "Visit sacred Buddhist temples",
      "Scenic train ride through hill country",
      "Visit the Temple of the Tooth in Kandy"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+5:30" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "7 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "Yes (ETA)" },
      { icon: <FaCity />, label: "Capital City", value: "Colombo" },
      { icon: <FaUsers />, label: "Population", value: "22 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Sri Lankan Rupee" }
    ]
  },
  {
    id: "southafrica",
    image: "/southafrica.jpg",
    location: "South Africa: Wildlife & Wonders",
    nights: 12,
    price: 1799,
    description: "Experience the incredible diversity of South Africa, from Cape Town's stunning landscapes to world-renowned wildlife reserves. A journey of breathtaking natural beauty, wildlife encounters, and rich cultural experiences.",
    highlights: [
      "Safari in Kruger National Park",
      "Explore Cape Town and Table Mountain",
      "Wine tasting in Stellenbosch",
      "Visit Robben Island",
      "Whale watching in Hermanus",
      "Drive along the scenic Garden Route",
      "Visit the Cape of Good Hope"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+2" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "11 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "No (for many nationalities)" },
      { icon: <FaCity />, label: "Capital Cities", value: "Pretoria, Cape Town, Bloemfontein" },
      { icon: <FaUsers />, label: "Population", value: "59 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "South African Rand" }
    ]
  },
  {
    id: "japan",
    image: "/japan.jpg",
    location: "Japan: Cherry Blossoms & Culture",
    nights: 10,
    price: 1999,
    description: "Immerse yourself in the rich traditions and futuristic cities of Japan, from the stunning cherry blossoms in Kyoto to the vibrant energy of Tokyo. A journey of cultural heritage, natural beauty, and modern wonders.",
    highlights: [
      "Witness cherry blossoms in Kyoto",
      "Explore the bustling streets of Tokyo",
      "Visit ancient temples in Nara",
      "Experience a traditional tea ceremony",
      "Relax in a Hakone hot spring",
      "Ride the famous Shinkansen bullet train",
      "Visit the Fushimi Inari Shrine in Kyoto"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+9" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "13 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "Yes (for most nationalities)" },
      { icon: <FaCity />, label: "Capital City", value: "Tokyo" },
      { icon: <FaUsers />, label: "Population", value: "126 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Japanese Yen" }
    ]
  },
  {
    id: "greece",
    image: "/greece.jpg",
    location: "Greece: Islands & Ancient Wonders",
    nights: 9,
    price: 1599,
    description: "Discover the breathtaking beauty of Greece, from the sun-soaked islands of Santorini to the historic ruins of Athens. A journey of crystal-clear waters, ancient landmarks, and rich Mediterranean flavors. A perfect place for historical tour and relaxation.",
    highlights: [
      "Explore the Acropolis in Athens",
      "Sail through the Cyclades islands",
      "Watch the sunset in Santorini",
      "Visit the monasteries of Meteora",
      "Taste authentic Greek cuisine",
      "Swim in the crystal waters of Mykonos",
      "Explore the ancient ruins of Delphi"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+2" },
      { icon: <FaPlane />, label: "Approx. Flight Time", value: "4 hours" },
      { icon: <FaPassport />, label: "Visa Required", value: "No (for EU & many nationalities)" },
      { icon: <FaCity />, label: "Capital City", value: "Athens" },
      { icon: <FaUsers />, label: "Population", value: "10.4 million" },
      { icon: <FaMoneyBillAlt />, label: "Currency", value: "Euro" }
    ]
  },
 {
    id: "kenya-safari",
    image: "/kenya-safari.webp",
    location: "Kenya: Big Five Safari Adventure",
    nights: 5,
    price: 2099,
    description: "Embark on an unforgettable 5-night safari adventure across Kenya's premier wildlife destinations. Journey from Amboseli's elephant herds against Mount Kilimanjaro to Lake Naivasha's hippo-filled waters and the legendary Masai Mara's Big Five territory.",
    highlights: [
      "Big Five game drives in Masai Mara's savannah",
      "Amboseli's elephants with Kilimanjaro backdrop",
      "Lake Naivasha boat safari among hippos",
      "Optional Maasai village cultural experience",
      "Seasonal Great Migration viewing at Mara River",
      "Full-board accommodation in 4-star safari lodges",
      "Scenic Great Rift Valley viewpoint stop"
    ],
    facts: [
      { icon: <FaClock />, label: "Time Difference", value: "GMT+3" },
      { icon: <FaPlane />, label: "Flight from London", value: "Included" },
      { icon: <FaPassport />, label: "Visa Required", value: "Yes (e-Visa available)" },
      { icon: <FaCity />, label: "Tour Starts/Ends", value: "Nairobi" },
      { icon: <FaUsers />, label: "Group Tour", value: "Private Driver-Guide" },
      { icon: <FaMoneyBillAlt />, label: "Best For", value: "Wildlife & Photography" }
    ]
}
];

const DestinationDetails = () => {
 
 const [selectedClass, setSelectedClass] = useState('Economy');
  const [selectedYear, setSelectedYear] = useState('2025');

   const [expandedDays, setExpandedDays] = useState({
    day1: false,
    day2: false,
    day3: false,
    day4: false,
    day5: false,
    day6: false
  });

  const toggleDay = (day) => {
    setExpandedDays(prev => ({
      ...prev,
      [day]: !prev[day]
    }));
  };

  const expandAll = () => {
    setExpandedDays({
      day1: true,
      day2: true,
      day3: true,
      day4: true,
      day5: true,
      day6: true
    });
  };

  const collapseAll = () => {
    setExpandedDays({
      day1: false,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false
    });
  };
  const { id } = useParams();
  const navigate = useNavigate();
  
  const destination = destinations.find(dest => dest.id === id); // No parseInt

  if (!destination) {
    return <h2>Destination Not Found</h2>;
  }


   
  
  // Dummy data structure
  const priceData = {
    Economy: {
      '2025': [
        { month: 'November', boardBasis: 'Full Board', nights: '5 Nights', price: '£2099 pp' },
        { month: 'December', boardBasis: 'Full Board', nights: '5 Nights', price: '£2099 pp' }
      ],
      '2026': [
        { month: 'January', boardBasis: 'Full Board', nights: '5 Nights', price: '£2399 pp' },
        { month: 'February', boardBasis: 'Full Board', nights: '5 Nights', price: '£2399 pp' },
        { month: 'March', boardBasis: 'Full Board', nights: '5 Nights', price: '£2399 pp' },
        { month: 'April', boardBasis: 'Full Board', nights: '5 Nights', price: '£2499 pp' },
        { month: 'May', boardBasis: 'Full Board', nights: '5 Nights', price: '£2399 pp' },
        { month: 'June', boardBasis: 'Full Board', nights: '5 Nights', price: '£2399 pp' },
        { month: 'July', boardBasis: 'Full Board', nights: '5 Nights', price: '£2699 pp' },
        { month: 'August', boardBasis: 'Full Board', nights: '5 Nights', price: '£2899 pp' },
        { month: 'September', boardBasis: 'Full Board', nights: '5 Nights', price: '£2649 pp' },
        { month: 'October', boardBasis: 'Full Board', nights: '5 Nights', price: '£2599 pp' },
        { month: 'November', boardBasis: 'Full Board', nights: '5 Nights', price: '£2399 pp' },
        { month: 'December', boardBasis: 'Full Board', nights: '5 Nights', price: '£2599 pp' },
      ],
      '2027': [
       { month: 'January', boardBasis: 'Full Board', nights: '5 Nights', price: '£2449 pp' },
        { month: 'February', boardBasis: 'Full Board', nights: '5 Nights', price: '£2649 pp' },
        { month: 'March', boardBasis: 'Full Board', nights: '5 Nights', price: '£2599 pp' },
        { month: 'April', boardBasis: 'Full Board', nights: '5 Nights', price: '£2699 pp' },
        { month: 'May', boardBasis: 'Full Board', nights: '5 Nights', price: '£2699 pp' },
        { month: 'June', boardBasis: 'Full Board', nights: '5 Nights', price: '£2649 pp' },
        { month: 'July', boardBasis: 'Full Board', nights: '5 Nights', price: '£2899 pp' },
        { month: 'August', boardBasis: 'Full Board', nights: '5 Nights', price: '£3149 pp' },
        { month: 'September', boardBasis: 'Full Board', nights: '5 Nights', price: '£2949 pp' },
        { month: 'October', boardBasis: 'Full Board', nights: '5 Nights', price: '£2849 pp' },
        { month: 'November', boardBasis: 'Full Board', nights: '5 Nights', price: '£2649 pp' },
        { month: 'December', boardBasis: 'Full Board', nights: '5 Nights', price: '£2849 pp' },
      ]
    },
    Business: {
      '2025': [
        { month: 'November', boardBasis: 'Full Board', nights: '5 Nights', price: '£3549 pp' },
        { month: 'December', boardBasis: 'Full Board', nights: '5 Nights', price: '£3549 pp' }
      ],
      '2026': [
        { month: 'January', boardBasis: 'Full Board', nights: '5 Nights', price: '£3799 pp' },
        { month: 'February', boardBasis: 'Full Board', nights: '5 Nights', price: '£3799 pp' },
        { month: 'March', boardBasis: 'Full Board', nights: '5 Nights', price: '£3799 pp' },
        { month: 'April', boardBasis: 'Full Board', nights: '5 Nights', price: '£3799 pp' },
        { month: 'May', boardBasis: 'Full Board', nights: '5 Nights', price: '£3799 pp' },
        { month: 'June', boardBasis: 'Full Board', nights: '5 Nights', price: '£3799 pp' },
        { month: 'July', boardBasis: 'Full Board', nights: '5 Nights', price: '£3999 pp' },
        { month: 'August', boardBasis: 'Full Board', nights: '5 Nights', price: '£3999 pp' },
        { month: 'September', boardBasis: 'Full Board', nights: '5 Nights', price: '£3999 pp' },
        { month: 'October', boardBasis: 'Full Board', nights: '5 Nights', price: '£3999 pp' },
        { month: 'November', boardBasis: 'Full Board', nights: '5 Nights', price: '£3949 pp' },
        { month: 'December', boardBasis: 'Full Board', nights: '5 Nights', price: '£4149 pp' },
      ],
      '2027': [
        { month: 'January', boardBasis: 'Full Board', nights: '5 Nights', price: '£4099 pp' },
        { month: 'February', boardBasis: 'Full Board', nights: '5 Nights', price: '£4099 pp' },
        { month: 'March', boardBasis: 'Full Board', nights: '5 Nights', price: '£4099 pp' },
        { month: 'April', boardBasis: 'Full Board', nights: '5 Nights', price: '£4149 pp' },
        { month: 'May', boardBasis: 'Full Board', nights: '5 Nights', price: '£4149 pp' },
        { month: 'June', boardBasis: 'Full Board', nights: '5 Nights', price: '£4149 pp' },
        { month: 'July', boardBasis: 'Full Board', nights: '5 Nights', price: '£4399 pp' },
        { month: 'August', boardBasis: 'Full Board', nights: '5 Nights', price: '£4399 pp' },
        { month: 'September', boardBasis: 'Full Board', nights: '5 Nights', price: '£4399 pp' },
        { month: 'October', boardBasis: 'Full Board', nights: '5 Nights', price: '£4399 pp' },
        { month: 'November', boardBasis: 'Full Board', nights: '5 Nights', price: '£4299 pp' },
        { month: 'December', boardBasis: 'Full Board', nights: '5 Nights', price: '£4549 pp' },
      ]
    }
  };

const handleNavigate = () => {
  navigate('/contactus/#c-uf');
};


  const handleScroll = () => {
    // Use the current destination id instead of activeId
    const targetId = id === "kenya-safari" ? "pr-d" : "pr-s";
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Add a small timeout to ensure DOM is ready
      setTimeout(() => {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    } else {
      console.warn(`Element with id ${targetId} not found`);
    }
  };
  return (
    <>
    <div className="destination-details">
      {/* Poster Section */}
      <div className="poster">
        <img src={destination.image} alt={destination.location} className="poster-image" />
        <div className="overlay">
          <h1 className="destination-name">{destination.location}</h1>
          <div className="button-overlay-f">
            <button className="button-overlay-d" onClick={handleNavigate}>Enquire Now</button>
            <button className="button-overlay-d"  onClick={handleScroll}>Check Prices</button>
          </div>
        </div>
      </div>
      <FlightDeal/>

      <div id="pr-s" className="main-d">
        {/* About Section */}
        <div className="about-m">
          <div className="about">
            <h2>About {destination.location}</h2>
            <p>{destination.description}</p>
            <p className="main-dp">Enjoy a {destination.nights}-night stay starting at £{destination.price}pp <span className="main-dp-span" onClick={handleNavigate}>Enquire Now</span></p>
          </div>
          <div className="highlights">
            <h2>Highlights</h2>
            <ul>
              {destination.highlights.map((highlight, index) => (
                <li key={index}>{highlight}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* All Destinations Grid */}
        <div className="destination-grid">
          <h2>More Holidays</h2>
          <div className="grid">
            {destinations.map(dest => (
              <div key={dest.id} className="grid-item" onClick={() => navigate(`/holidays/${dest.id}`)}>
                <img src={dest.image} alt={dest.location} />
                <p>{dest.location}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

       {/* Conditionally render brief-k section only for kenya-safari */}
      {id === "kenya-safari" && (
        <section className="brief-k">
          <div className="brief-container-k">
            <div className="brief-header-k">
              <h2 className="brief-heading-k">Kenya Safari Adventure Brief</h2>
              <p className="brief-description-k">
                Embark on an extraordinary 5-night journey through Kenya's legendary Masai Mara, 
                where Africa's wild heart beats strongest. This carefully curated safari experience 
                transports you across golden savannahs teeming with wildlife, offering thrilling game 
                drives and authentic cultural encounters with the Maasai people. Discover untamed nature, 
                breathtaking landscapes, and luxurious comfort in handpicked accommodations that place 
                you at the center of the wilderness.
              </p>
            </div>
            
            <div className="attractions-section-k">
              <h3 className="attractions-heading-k">Key Attractions</h3>
              <div className="attractions-list-k">
                <span className="attraction-item-k">Great Rift Valley Viewpoint</span>
                <span className="divider-k">|</span>
                <span className="attraction-item-k">Masai Mara National Reserve</span>
                <span className="divider-k">|</span>
                <span className="attraction-item-k">Big Five Safari Game Drives</span>
                <span className="divider-k">|</span>
                <span className="attraction-item-k">Mara River Migration Viewpoint</span>
                <span className="divider-k">|</span>
                <span className="attraction-item-k">Maasai Cultural Experience</span>
                <span className="divider-k">|</span>
                <span className="attraction-item-k">Wildlife Spotting</span>
                <span className="divider-k">|</span>
                <span className="attraction-item-k">Wildebeest </span>
                <span className="divider-k">|</span>
                <span className="attraction-item-k">Lake Naivasha Boat Safari</span>
              
              </div>
            </div>
          </div>
        </section>
      )}

 {id === "kenya-safari" && (
       <div className="kenya-safari">
      <div className="itinerary-header">
        <h2>Itinerary Details</h2>
        <div className="expand-controls">
          <button onClick={expandAll} className="expand-btn">Expand All</button>
          <button onClick={collapseAll} className="collapse-btn">Collapse All</button>
        </div>
      </div>
      
      {/* Day 1 */}
      <div className={`day-item ${expandedDays.day1 ? 'expanded' : ''}`}>
        <div className="day-header" onClick={() => toggleDay('day1')}>
          <div className="day-title">
            <span className="day-number">DAY 1</span>
            <span className="day-description">| WELCOME TO KENYA – OFF TO AMBOSELI NATIONAL PARK</span>
          </div>
          <div className="toggle-icon">
            {expandedDays.day1 ? '-' : '+'}
          </div>
        </div>
        
        {expandedDays.day1 && (
          <div className="day-content">
            <div className="content-left">
              <h3 className="location">Amboseli National Park</h3>
              <p>On arrival at Jomo Kenyatta International Airport our representative will be waiting to greet you with a warm smile and a wave. From here, your safari adventure begins as you head straight to the legendary Amboseli National Park, known for its vast herds of elephants and stunning views of Mount Kilimanjaro.</p>
              <p>Check in, enjoy a delicious hot lunch at your hotel, and then head out on your first game drive & your camera should be ready, as this could be your first sighting of elephants, zebras, or even lions with Kilimanjaro in the backdrop.</p>
              <p>Overnight at Amboseli Sopa Lodge or similar.</p>
              <p className="drive-time">Drive time: Approx. 4 hours</p>
            </div>
            <div className="content-right">
              <div className="image-placeholder">
              <img src="/kenya1.jpg" alt="kenya-safari" className="vfg-pic"/>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Day 2 */}
      <div className={`day-item ${expandedDays.day2 ? 'expanded' : ''}`}>
        <div className="day-header" onClick={() => toggleDay('day2')}>
          <div className="day-title">
            <span className="day-number">DAY 2</span>
            <span className="day-description">| EXPLORE AMBOSELI – LAND OF GIANTS</span>
          </div>
          <div className="toggle-icon">
            {expandedDays.day2 ? '-' : '+'}
          </div>
        </div>
        
        {expandedDays.day2 && (
          <div className="day-content">
            <div className="content-left">
              <h3 className="location">Amboseli National Park</h3>
              <p>Wake up to the sounds of nature and prepare for a full day exploring the wild plains of Amboseli. With both morning and afternoon game drives, you will have plenty of chances to spot elephants, wildebeest, giraffes, cheetahs, and more.</p>
              <p>Then gear up yourself, spend the midday relaxing at the lodge, soaking in the peaceful landscape.</p>
              <p>Overnight at Amboseli Sopa Lodge or similar.</p>
            </div>
            <div className="content-right">
              <div className="image-placeholder">
                <img src="/kenya2.webp" alt="kenya-safari" className="vfg-pic"/>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Day 3 */}
      <div className={`day-item ${expandedDays.day3 ? 'expanded' : ''}`}>
        <div className="day-header" onClick={() => toggleDay('day3')}>
          <div className="day-title">
            <span className="day-number">DAY 3</span>
            <span className="day-description">| FROM KILIMANJARO TO THE SHORES OF LAKE NAIVASHA</span>
          </div>
          <div className="toggle-icon">
            {expandedDays.day3 ? '-' : '+'}
          </div>
        </div>
        
        {expandedDays.day3 && (
          <div className="day-content">
            <div className="content-left">
              <h3 className="location">Lake Naivasha</h3>
              <p>After breakfast, it is time to count the open plains for tranquil waters as now you have to proceed toward Lake Naivasha. Make sure your camera is handy as you will stop at a Great Rift Valley viewpoint for some of the most epic photos of the trip.</p>
              <p>Once you arrive the hotel check in & enjoy delicious lunch and a peaceful afternoon boat ride across the lake, often surrounded by hippos and exotic birdlife.</p>
              <p>Overnight at Lake Naivasha Simba Lodge.</p>
              <p className="drive-time">Drive time: Approx. 6 hours</p>
            </div>
            <div className="content-right">
              <div className="image-placeholder">
                <img src="/kenya3.jpg" alt="kenya-safari" className="vfg-pic"/>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Day 4 */}
      <div className={`day-item ${expandedDays.day4 ? 'expanded' : ''}`}>
        <div className="day-header" onClick={() => toggleDay('day4')}>
          <div className="day-title">
            <span className="day-number">DAY 4</span>
            <span className="day-description">| ONWARD TO MASAI MARA – THE HEART OF THE WILD</span>
          </div>
          <div className="toggle-icon">
            {expandedDays.day4 ? '-' : '+'}
          </div>
        </div>
        
        {expandedDays.day4 && (
          <div className="day-content">
            <div className="content-left">
              <h3 className="location">Maasai Mara National Reserve</h3>
              <p>Today, you are off to the crown jewel of Kenya's safari circuit called Masai Mara National Reserve. Arrive in time for lunch, and after a quick refresh, head out for your first game drive in the Mara.</p>
              <p>The golden light of the afternoon brings the savannah to life & be ready to witness lions, elephants, buffalo, and maybe even the elusive leopard.</p>
              <p>Overnight at Mara Simba Lodge or similar.</p>
              <p className="drive-time">Drive time: Approx. 5 hours</p>
            </div>
            <div className="content-right">
              <div className="image-placeholder">
                  <img src="/kenya4.webp" alt="kenya-safari" className="vfg-pic"/>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Day 5 */}
      <div className={`day-item ${expandedDays.day5 ? 'expanded' : ''}`}>
        <div className="day-header" onClick={() => toggleDay('day5')}>
          <div className="day-title">
            <span className="day-number">DAY 5</span>
            <span className="day-description">| FULL DAY IN MASAI MARA – ADVENTURE UNLIMITED</span>
          </div>
          <div className="toggle-icon">
            {expandedDays.day5 ? '-' : '+'}
          </div>
        </div>
        
        {expandedDays.day5 && (
          <div className="day-content">
            <div className="content-left">
              <h3 className="location">Maasai Mara National Reserve</h3>
              <p>Start your day with an early morning game drive, the best time to spot big cats on the hunt. Return for a hearty breakfast, then relax at the lodge or explore at your own pace.</p>
              <p>In the afternoon, head out again for more wildlife encounters or choose to spend the whole day on safari with a picnic lunch in the bush (a true safari experience!).</p>
              <p>Want to connect with local culture? Opt for an optional visit to a Masai village this afternoon, where you will get a chance meet the local community, learn traditional dances, and see their way of life.</p>
              <p>Overnight at Mara Simba Lodge or similar.</p>
            </div>
            <div className="content-right">
              <div className="image-placeholder">
                  <img src="/kenya5.webp" alt="kenya-safari" className="vfg-pic"/>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Day 6 */}
      <div className={`day-item ${expandedDays.day6 ? 'expanded' : ''}`}>
        <div className="day-header" onClick={() => toggleDay('day6')}>
          <div className="day-title">
            <span className="day-number">DAY 6</span>
            <span className="day-description">| GOOD BYE SAVANNAH – BACK TO NAIROBI</span>
          </div>
          <div className="toggle-icon">
            {expandedDays.day6 ? '-' : '+'}
          </div>
        </div>
        
        {expandedDays.day6 && (
          <div className="day-content">
            <div className="content-left">
              <h3 className="location">Nairobi</h3>
              <p>Enjoy a leisurely breakfast as you take in the final views of the wild. Then, begin your scenic journey back to Nairobi, filled with memories, stories, and may be thousands of photos.</p>
              <p>We will drop you off at Nairobi Airport in time for your onward flight after a warming goodbye and wishing to see you soon again!</p>
            </div>
            <div className="content-right">
              <div className="image-placeholder">
                 <img src="/kenya6.jpg" alt="kenya-safari" className="vfg-pic"/>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
     )}


 {id === "kenya-safari" && (

      <div className="kenya-table-container">
  <div className="table-section">
    <h2 className="section-title">
      Accommodation Details
    </h2>
    <div className="table-wrapper">
      <table className="accommodation-table">
        <thead>
          <tr>
            <th>Destination</th>
            <th>Nights</th>
            <th>Hotel Name</th>
            <th>Room Category</th>
            <th>Board Basis</th>
            <th>Rating</th>
          </tr>
        </thead>
        <tbody>
          <tr className="table-row">
            <td className="destination-cell">
              <span className="destination-namee">Amboseli National Park</span>
              <span className="destination-desc">Breathtaking views of Mount Kilimanjaro</span>
            </td>
            <td className="nights-cell">
              <span className="nights-badge">2</span>
            </td>
            <td className="hotel-cell">Amboseli Sopa Lodge or Similar</td>
            <td className="room-cell">Standard Double or Twin Room</td>
            <td className="board-cell">
              <span className="board-badge">Full Board</span>
            </td>
            <td className="rating-cell">
              <span className="stars">★★★★</span>
              <span className="rating-text">4 star</span>
            </td>
          </tr>
          <tr className="table-row">
            <td className="destination-cell">
              <span className="destination-namee">Lake Naivasha</span>
              <span className="destination-desc">Freshwater lake with hippo colonies</span>
            </td>
            <td className="nights-cell">
              <span className="nights-badge">1</span>
            </td>
            <td className="hotel-cell">Lake Naivasha Simba Lodge</td>
            <td className="room-cell">Double or Twin Room</td>
            <td className="board-cell">
              <span className="board-badge">Full Board</span>
            </td>
            <td className="rating-cell">
              <span className="stars">★★★★</span>
              <span className="rating-text">4 star</span>
            </td>
          </tr>
          <tr className="table-row">
            <td className="destination-cell">
              <span className="destination-namee">Masai Mara National Reserve</span>
              <span className="destination-desc">Home of the Great Wildebeest Migration</span>
            </td>
            <td className="nights-cell">
              <span className="nights-badge">2</span>
            </td>
            <td className="hotel-cell">Mara Simba Lodge or Similar</td>
            <td className="room-cell">Double Room-Tent</td>
            <td className="board-cell">
              <span className="board-badge">Full Board</span>
            </td>
            <td className="rating-cell">
              <span className="stars">★★★★</span>
              <span className="rating-text">4 star</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


      <div className="inclusions-section">
        <h2 className="section-title">
         
          Package Inclusions
        </h2>
        <div className="info-cards">
        <div className="info-card">
  <h3>Special Offers</h3>
  <p>Exclusive offers may apply and will be communicated as available.</p>
</div>
          <div className="info-card">
            <h3> Extended Booking Period</h3>
            <p>Reservations open for 2025, 2026 & 2027 with flexible planning options</p>
          </div>
          <div className="info-card">
            <h3> Return Flight Package</h3>
            <p>Round-trip flights from London included (supplements may apply for other departure airports)</p>
          </div>
          <div className="info-card">
            <h3> Full Board Accommodation</h3>
            <p>05 nights luxury stay with all meals included throughout your safari experience</p>
          </div>
          <div className="info-card">
            <h3> Safari Transport</h3>
            <p>Comfortable 4x4 Land Cruiser with pop-up roof for optimal game viewing experiences</p>
          </div>
          <div className="info-card">
            <h3> Park Entry Fees</h3>
            <p>All access fees for Amboseli National Park and Masai Mara National Reserve included</p>
          </div>
          <div className="info-card">
            <h3>Lake Naivasha Boat Ride</h3>
            <p>One hour scenic boat excursion on Lake Naivasha to observe hippos and birdlife</p>
          </div>
          <div className="info-card">
            <h3> Daily Refreshments</h3>
            <p>1 litre of mineral water per person each day during safari drives</p>
          </div>
          <div className="info-card">
            <h3>Expert Safari Guide</h3>
            <p>Services of an experienced English-speaking driver guide throughout your journey</p>
          </div>
          <div className="info-card">
            <h3>Government Taxes</h3>
            <p>All applicable government taxes and service charges included in package price</p>
          </div>
          <div className="info-card">
  <h3>Trip Extensions</h3>
  <p>Extensions to Mombasa and Zanzibar available on request with flexible stay options.</p>
</div>

<div className="info-card">
  <h3>Hotel Availability</h3>
  <p>Hotels or rooms may vary by availability. Updates will be shared.</p>
</div>

        </div>
      </div>

     
    </div>
       )}

    

 {id === "kenya-safari" && (
<section id="pr-d" className="kenya-price-section-kn">
  <div className="container-kn">
    <div className="header-section-kn">
      <h2 className="section-title-kn">PRICES *</h2>
      <p className="section-subtitle-kn">Explore our competitive pricing for Kenya safaris</p>
    </div>
    <div className="both-toggle">
      {/* Class toggle buttons */}
      <div className="toggle-group-kn class-toggle-kn">
        <button 
          className={`toggle-btn-kn ${selectedClass === 'Economy' ? 'active-kn' : ''}`}
          onClick={() => setSelectedClass('Economy')}
        >
          Economy
        </button>
        <button 
          className={`toggle-btn-kn ${selectedClass === 'Business' ? 'active-kn' : ''}`}
          onClick={() => setSelectedClass('Business')}
        >
          Business
        </button>
      </div>
      
      {/* Year toggle buttons */}
      <div className="toggle-group-kn year-toggle-kn">
        <button 
          className={`toggle-btn-kn ${selectedYear === '2025' ? 'active-kn' : ''}`}
          onClick={() => setSelectedYear('2025')}
        >
          2025
        </button>
        <button 
          className={`toggle-btn-kn ${selectedYear === '2026' ? 'active-kn' : ''}`}
          onClick={() => setSelectedYear('2026')}
        >
          2026
        </button>
        <button 
          className={`toggle-btn-kn ${selectedYear === '2027' ? 'active-kn' : ''}`}
          onClick={() => setSelectedYear('2027')}
        >
          2027
        </button>
      </div>
    </div>
    
    {/* Price table */}
    <div className="price-table-kn">
      <div className="table-header-kn">
        <div className="header-cell-kn">Month</div>
        <div className="header-cell-kn">Board Basis</div>
        <div className="header-cell-kn">Nights</div>
        <div className="header-cell-kn">Price</div>
        <div className="header-cell-kn">Action</div>
      </div>
      
      <div className="table-body-kn">
        {priceData[selectedClass][selectedYear].map((item, index) => (
          <div className="table-row-kn" key={index}>
            <div className="table-cell-kn month-cell-kn" data-label="Month">{item.month}</div>
            <div className="table-cell-kn" data-label="Board Basis">{item.boardBasis}</div>
            <div className="table-cell-kn" data-label="Nights">{item.nights}</div>
            <div className="table-cell-kn price-cell-kn" data-label="Price">{item.price}</div>
            <div className="table-cell-kn" data-label="Action">
              
                <button className="enquire-btn-kn" onClick={handleNavigate}>Enquire now</button>
             
            </div>
          </div>
        ))}
      </div>
    </div>
    
    <div className="footer-section-kn">
      <p className="price-note-kn">* Prices may vary as per the availability</p>
      <div className="info-badge-kn">
        <span className="badge-icon-kn">ℹ️</span>
        <span>All prices are per person</span>
      </div>
    </div>
  </div>
</section>
        )}

{id === "kenya-safari" && (
          <section className="hotel-kenya-section-knh">
      <div className="container-knh">
        <h2 className="section-heading-knh">Hotels</h2>
        
        {/* Hotel 1 */}
        <div className="hotel-card-knh">
          <div className="hotel-header-knh">
            <div className="hotel-image-knh">
              <img src="/kenyahotel1.jpg" alt="Amboseli Sopa Lodge" />
            </div>
            <div className="hotel-info-knh">
              <div className="hotel-title-section-knh">
                <h3 className="hotel-name-knh">Amboseli Sopa Lodge</h3>
                <div className="hotel-rating-knh">
                  <span className="stars-knh">★★★★☆</span>
                  <span className="rating-text-knh">4.5/5</span>
                </div>
              </div>
              
              <div className="services-section-knh">
                <h4>Services & Amenities</h4>
                <div className="services-list-knh">
                  <div className="service-item-knh">Outdoor swimming pool</div>
                  <div className="service-item-knh">Free parking</div>
                  <div className="service-item-knh">Free Wifi</div>
                  <div className="service-item-knh">Non-smoking rooms</div>
                  <div className="service-item-knh">Restaurant</div>
                  <div className="service-item-knh">Room service</div>
                  <div className="service-item-knh">Disabled guests</div>
                  <div className="service-item-knh">Family rooms</div>
                  <div className="service-item-knh">Bar</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="hotel-details-knh">
            <div className="detail-section-knh">
              <h4>Accommodation</h4>
              <p>Amboseli Sopa Lodge offers elegantly appointed rooms and suites for all types of travelers. Choose from our 83 beautifully designed guestrooms, including standard rooms, deluxe rooms, and suites. Each accommodation features modern amenities like Wi-Fi, flat-screen TVs, minibars, premium bedding, and marble bathrooms. Enjoy breathtaking views of the gardens or majestic Mount Kilimanjaro from your private balcony, complemented by luxurious touches like exclusive toiletries and plush robes.</p>
            </div>
            
            <div className="detail-section-knh">
              <h4>Amenities</h4>
              <p>Experience first-class services including personalized concierge assistance, valet parking, and private cabana rentals. Business travelers will appreciate our fully equipped business center, while VIP guests can enjoy exclusive services like dedicated butler assistance and luxury transportation options.</p>
            </div>
            
            <div className="detail-section-knh">
              <h4>Dining Options</h4>
              <p>Savor exceptional culinary experiences at our 'Kilimanjaro Restaurant' featuring international cuisine with distinctive African influences. Dine under the stars on our open-air terrace or enjoy exotic cocktails with panoramic wilderness views at the 'Observatory Bar'. For ultimate privacy, 24/7 room service is available for intimate dining experiences.</p>
            </div>
          </div>
        </div>
        
        {/* Hotel 2 */}
        <div className="hotel-card-knh">
          <div className="hotel-header-knh">
            <div className="hotel-image-knh">
              <img src="/kenyahotel2.jpg" alt="Lake Naivasha Simba Lodge" />
            </div>
            <div className="hotel-info-knh">
              <div className="hotel-title-section-knh">
                <h3 className="hotel-name-knh">Lake Naivasha Simba Lodge</h3>
                <div className="hotel-rating-knh">
                  <span className="stars-knh">★★★★☆</span>
                  <span className="rating-text-knh">4.2/5</span>
                </div>
              </div>
              
              <div className="services-section-knh">
                <h4>Services & Amenities</h4>
                <div className="services-list-knh">
                  <div className="service-item-knh">Outdoor swimming pool</div>
                  <div className="service-item-knh">Free parking</div>
                  <div className="service-item-knh">Free Wifi</div>
                  <div className="service-item-knh">Non-smoking rooms</div>
                  <div className="service-item-knh">Restaurant</div>
                  <div className="service-item-knh">Room service</div>
                  <div className="service-item-knh">Disabled guests</div>
                  <div className="service-item-knh">Family rooms</div>
                  <div className="service-item-knh">Bar</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="hotel-details-knh">
            <div className="detail-section-knh">
              <h4>Accommodation</h4>
              <p>Discover tranquility at Lake Naivasha Simba Lodge, a serene 3-star retreat featuring 70 beautifully furnished rooms with elegant wrought iron and mahogany furniture. Each room is equipped with tea/coffee facilities, Wi-Fi, satellite TV, and in-room safes. Situated alongside the picturesque Lake Naivasha, our lodge provides a peaceful atmosphere perfect for relaxation while offering convenient access to outdoor adventures like boat excursions and nature trails.</p>
            </div>
            
            <div className="detail-section-knh">
              <h4>Amenities</h4>
              <p>Enjoy our extensive facilities including an eco-friendly solar-heated swimming pool, comprehensive fitness center with sauna and steam room, tennis court, and rejuvenating spa treatments. Additional recreational options include boat rides, guided nature walks, and a dedicated children's pool. We also provide meeting spaces, a curated gift shop, professional babysitting services, and fully accessible facilities for guests with disabilities.</p>
            </div>
            
            <div className="detail-section-knh">
              <h4>Dining Options</h4>
              <p>Indulge in diverse culinary offerings at our restaurant, where our chefs prepare delicious meals using fresh, locally sourced ingredients. Our dining venues provide the perfect setting for every meal, from casual breakfasts to romantic dinners with stunning lake views. Special dietary requirements can be accommodated with advance notice.</p>
            </div>
          </div>
        </div>
        
        {/* Hotel 3 */}
        <div className="hotel-card-knh">
          <div className="hotel-header-knh">
            <div className="hotel-image-knh">
              <img src="/kenyahotel3.jpg" alt="Mara Simba Lodge" />
            </div>
            <div className="hotel-info-knh">
              <div className="hotel-title-section-knh">
                <h3 className="hotel-name-knh">Mara Simba Lodge</h3>
                <div className="hotel-rating-knh">
                  <span className="stars-knh">★★★★★</span>
                  <span className="rating-text-knh">4.7/5</span>
                </div>
              </div>
              
              <div className="services-section-knh">
                <h4>Services & Amenities</h4>
                <div className="services-list-knh">
                  <div className="service-item-knh">Outdoor swimming pool</div>
                  <div className="service-item-knh">Free parking</div>
                  <div className="service-item-knh">Free Wifi</div>
                  <div className="service-item-knh">Non-smoking rooms</div>
                  <div className="service-item-knh">Restaurant</div>
                  <div className="service-item-knh">Room service</div>
                  <div className="service-item-knh"> Disabled guests</div>
                  <div className="service-item-knh">Family rooms</div>
                  <div className="service-item-knh">Bar</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="hotel-details-knh">
            <div className="detail-section-knh">
              <h4>Accommodation</h4>
              <p>Mara Simba Lodge presents comfortable and stylish accommodations nestled in the heart of the Maasai Mara. Our spacious tents beautifully blend rustic charm with modern comforts, offering guests spectacular views of the savannah and close encounters with wildlife. Experience the perfect harmony of adventure and relaxation with cozy interiors, genuine hospitality, and convenient access to game drives for an authentic safari experience.</p>
            </div>
            
            <div className="detail-section-knh">
              <h4>Amenities</h4>
              <p>Our lodge features comfortable accommodations with en-suite bathrooms and private verandas overlooking the Talek River. Facilities include a refreshing swimming pool, restaurant, bar, rejuvenating spa, and fitness gym. Enjoy traditional Maasai cultural performances and optional safari activities like hot air balloon rides and guided nature walks. Additional services include laundry facilities and 24-hour front desk assistance.</p>
            </div>
            
            <div className="detail-section-knh">
              <h4>Dining Options</h4>
              <p>Delight in buffet-style dining featuring a delightful mix of international and local Kenyan specialties, served in our dining area with panoramic views of the Talek River. For unique experiences, we offer special bush dinners, sunset cocktails, and elegant black-tie dinners under the African stars, transforming mealtime into unforgettable safari memories.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
       )}


{id === "kenya-safari" && (
         <section className="kenya-brief">
      <div className="kenya-brief-container">
        <div className="title-section">
          <h1 className="kenya-brief-title">HOLIDAY BRIEF KENYA SAFARI</h1>
         
        </div>
        
        <div className="kenya-brief-content">
          <div className="kenya-brief-column">
            <div className="kenya-brief-item">
              <div className="arrow-container">
                <span className="kenya-brief-arrow">›</span>
              </div>
              <span className="kenya-brief-text">Best Safari In Kenya</span>
              <div className="item-hover"></div>
            </div>
            <div className="kenya-brief-item">
              <div className="arrow-container">
                <span className="kenya-brief-arrow">›</span>
              </div>
              <span className="kenya-brief-text">Kenya Holidays</span>
              <div className="item-hover"></div>
            </div>
            
           
          </div>
          
          <div className="kenya-brief-column">
           
            <div className="kenya-brief-item">
              <div className="arrow-container">
                <span className="kenya-brief-arrow">›</span>
              </div>
              <span className="kenya-brief-text">Safari Kenya Masai Mara</span>
              <div className="item-hover"></div>
            </div>
            <div className="kenya-brief-item">
              <div className="arrow-container">
                <span className="kenya-brief-arrow">›</span>
              </div>
              <span className="kenya-brief-text">Kenya Safari Holidays</span>
              <div className="item-hover"></div>
            </div>
           
          </div>
          
          <div className="kenya-brief-column">
            <div className="kenya-brief-item">
              <div className="arrow-container">
                <span className="kenya-brief-arrow">›</span>
              </div>
              <span className="kenya-brief-text">Luxury Kenya Safari</span>
              <div className="item-hover"></div>
            </div>
            <div className="kenya-brief-item">
              <div className="arrow-container">
                <span className="kenya-brief-arrow">›</span>
              </div>
              <span className="kenya-brief-text">Kenya Safari Tours</span>
              <div className="item-hover"></div>
            </div>
           
          </div>




          <div className="kenya-brief-column">
            <div className="kenya-brief-item">
              <div className="arrow-container">
                <span className="kenya-brief-arrow">›</span>
              </div>
              <span className="kenya-brief-text">Kenya Safari Nairobi</span>
              <div className="item-hover"></div>
            </div>
              <div className="kenya-brief-item">
              <div className="arrow-container">
                <span className="kenya-brief-arrow">›</span>
              </div>
              <span className="kenya-brief-text">Masai Mara Kenya</span>
              <div className="item-hover"></div>
            </div>
          </div>
        </div>
        
        <div className="background-elements">
          <div className="bg-element-1"></div>
          <div className="bg-element-2"></div>
          <div className="bg-element-3"></div>
        </div>
      </div>

    </section>
      )}

        {/* Useful Facts Section */}
      {destination.facts && (
        <div className="useful-facts">
          <h2>Useful Facts About {destination.location}</h2>
          <div className="facts-grid">
            {destination.facts.map((fact, index) => (
              <div key={index} className="fact-item">
                <div className="fact-icon">{fact.icon}</div>
                <div className="fact-label">{fact.label}</div>
                <div className="fact-value">{fact.value}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <WhyChoose />
      <Newsletter/>
    </div>


 
    </>
  );
};

export default DestinationDetails;
